import { AccountRequiredState } from 'types/account';
import { confirmPasswordVerified } from './account-state-guards';
import { RouteConfig } from 'vue-router';
import { user } from '@store/modules/user';
import { verifyRequiredStates } from './account-state-guards';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const accountSecurityRoutes: Array<RouteConfig> = [
	{
		path: `/account/security/mobile-number/login-verify`,
		name: 'login-mobile-verify',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		beforeEnter: async (to, from, next) => {
			await user.storePhoneData();
			next();
		},
		component: () =>
			import(/* webpackChunkName: "login-mobile-verify" */ '@views/account/login/login-mobile-verify.vue'),
		redirect: { name: 'login-mobile-verify-select' },
		children: [
			{
				path: `select`,
				name: 'login-mobile-verify-select',
				meta: { minTokenScopeRequired: 'FULL_ACCESS' },
				beforeEnter: async (to, from, next) => {
					const requiredStates: Array<AccountRequiredState> = [
						'userPhoneNotVerified',
						'userHasCurrentPhone',
						'userIsNotRestrictedFromVisitingMobileVerifyFlow'
					];
					await verifyRequiredStates(next, requiredStates);
				},
				component: () =>
					import(
						/* webpackChunkName: "login-mobile-verify-select" */ '@src/views/account/login/login-mobile-verify-select.vue'
					)
			},
			{
				path: `confirm`,
				name: 'login-mobile-verify-confirm',
				meta: { minTokenScopeRequired: 'FULL_ACCESS' },
				beforeEnter: async (to, from, next) => {
					const requiredStates: Array<AccountRequiredState> = [
						'userPhoneNotVerified',
						'userHasCurrentPhone',
						'userHasCompletedSelectInCurrentSession'
					];
					await verifyRequiredStates(next, requiredStates);
				},
				component: () =>
					import(
						/* webpackChunkName: "login-mobile-verify-confirm" */ '@src/views/account/login/login-mobile-verify-confirm.vue'
					)
			}
		]
	},
	{
		path: `/account/security/mobile-number/verify`,
		name: 'mobile-number-verify',
		meta: { minTokenScopeRequired: 'PRIVILEGED_ACCESS' },
		beforeEnter: async (to, from, next) => {
			await user.storePhoneData();
			await confirmPasswordVerified(next, 'mobile-number-verify', 'profile-personal-information-view');
		},
		component: () =>
			import(/* webpackChunkName: "mobile-number-verify" */ '@views/account/security/mobile-number-verify.vue')
	},
	{
		path: `/account/security/verify-password`,
		name: 'password-verify',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		component: () => import(/* webpackChunkName: "password-verify" */ '@views/account/security/password-verify.vue')
	}
];
export default accountSecurityRoutes;
